module.exports = __webpack_public_path__ + "img/p21-desc.48d00349.png";